import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const Breadcrumb = () => {
  const { t } = useTranslation('minimumFeesModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.invoices', 'Facturación') },
      {
        label: <span className="text-title">{t('breadcrumb.minimumFees', 'Cuota mínima')}</span>,
      },
    ],
    [t],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
